export default __webpack_public_path__ + "static/media/solid_circle_button.8ed66e1d.svg";